import clsx from "clsx";
import { SubmitButtonPropTypes } from "./propTypes";
import "./styles.scss";

const SubmitButton = ({
  action,
  className,
  Icon,
  iconPosition = "right",
  isDisabled = false,
  isSubmit = false,
  name,
  onlyIcon = false,
  showLabel = true,
}) => {
  return (
    <button
      className={clsx("submit-button-container-component", {
        disabled: isDisabled,
        [className]: className,
      })}
      disabled={isDisabled}
      onClick={action ?? null}
      type={`${isSubmit ? "submit" : "button"}`}
    >
      {iconPosition === "left" && Icon && (
        <i className={clsx({ "mr-2": !onlyIcon })}>
          <Icon />
        </i>
      )}

      {showLabel && <span dangerouslySetInnerHTML={{ __html: name }} />}

      {iconPosition === "right" && Icon && (
        <i className={clsx({ "ml-2": !onlyIcon })}>
          <Icon />
        </i>
      )}
    </button>
  );
};

SubmitButton.propTypes = SubmitButtonPropTypes;

export default SubmitButton;
